/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-07-30 17:14:38
 */

import { useEffect, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { useAppDispatch } from '../../../app/hooks'
import { setPaymentVisible } from '../../../actions/main'

import imgMonth0 from '../../../images/datepicker/0.png'
import imgMonth1 from '../../../images/datepicker/1.png'
import imgMonth2 from '../../../images/datepicker/2.png'
import imgMonth3 from '../../../images/datepicker/3.png'
import imgMonth4 from '../../../images/datepicker/4.png'
import imgMonth5 from '../../../images/datepicker/5.png'
import imgMonth6 from '../../../images/datepicker/6.png'
import imgMonth7 from '../../../images/datepicker/7.png'
import imgMonth8 from '../../../images/datepicker/8.png'
import imgMonth9 from '../../../images/datepicker/9.png'
import imgMonth10 from '../../../images/datepicker/10.png'
import imgMonth11 from '../../../images/datepicker/11.png'

export const useDatesSummary = (
  startDate: Dayjs,
  endDate: Dayjs,
  isFinishSelected: boolean
): string => {
  const [datesSummary, setDatesSummary] = useState('')

  useEffect(() => {
    const calculateDateSummary = () => {
      if (!isFinishSelected) {
        setDatesSummary('请选择结束时间')
        return
      }
      const start = dayjs(startDate)
      const end = dayjs(endDate)
      const years = end.diff(start, 'years')
      const months = end.diff(dayjs(start).add(years, 'year'), 'months')
      const days = end.diff(
        dayjs(start).add(years, 'year').add(months, 'month'),
        'days'
      )
      if (
        start.isSame(dayjs('1970-01-01')) &&
        end.isSame(dayjs().endOf('day'))
      ) {
        setDatesSummary('所有时间')
      } else if (
        dayjs().subtract(6, 'months').startOf('day').isSame(start, 'day') &&
        dayjs().endOf('day').isSame(end, 'day')
      ) {
        setDatesSummary('过去6个月')
      } else if (years > 0) {
        setDatesSummary(
          `${start.format('YYYY-MM-DD')} 至 ${end.format(
            'YYYY-MM-DD'
          )} 共${years}年${months}月${days + 1}天`
        )
      } else if (years === 0 && months > 0) {
        setDatesSummary(
          `${start.format('YYYY-MM-DD')} 至 ${end.format(
            'YYYY-MM-DD'
          )} 共${months}月${days + 1}天`
        )
      } else if (years === 0 && months === 0) {
        setDatesSummary(
          `${start.format('YYYY-MM-DD')} 至 ${end.format('YYYY-MM-DD')} 共${
            days + 1
          }天`
        )
      }
    }
    calculateDateSummary()
  }, [startDate, endDate, isFinishSelected])

  return datesSummary
}

export const useTimeSummary = (startTime: Dayjs, endTime: Dayjs): string => {
  const [timeSummary, setTimeSummary] = useState('')
  useEffect(() => {
    if (
      startTime.isSame(startTime.clone().startOf('day'), 'minute') &&
      endTime.isSame(endTime.clone().endOf('day'), 'minute')
    ) {
      setTimeSummary('全天')
    } else {
      setTimeSummary(
        `${startTime.format('HH:mm')} ~ ${endTime.format('HH:mm')}`
      )
    }
  }, [startTime, endTime])
  return timeSummary
}

export const usePayment = (): (() => void) => {
  const dispatch = useAppDispatch()
  const matchSourceDetail = () => {
    const pathname = window.location.pathname
    if (
      pathname === '/photo/all' ||
      pathname === '/' ||
      pathname === '/photo'
    ) {
      return 'allPhotoChooseDate'
    } else if (pathname === '/attendance/daily') {
      return 'attendanceDailyChooseDate'
    } else if (pathname === '/attendance/period') {
      return 'attendancePeriodChooseDate'
    } else if (pathname === '/watermark/data') {
      return 'watermarkDataChooseDate'
    } else if (/\/photo\/folder\/add\/\d+/.test(pathname)) {
      return 'photoFolderChooseDate'
    } else {
      return pathname
    }
  }
  return () => dispatch(setPaymentVisible(true, matchSourceDetail()))
}

export const monthBgImgs: string[] = [
  imgMonth0,
  imgMonth1,
  imgMonth2,
  imgMonth3,
  imgMonth4,
  imgMonth5,
  imgMonth6,
  imgMonth7,
  imgMonth8,
  imgMonth9,
  imgMonth10,
  imgMonth11
]
